import type { Publication } from "../interface/publications"
import type { PublicationEditable } from "../utils/patches"

export interface PublicationSessionDraft {
  /** null denotes a new publication, whose key is a client-generated UUID. */
  baseline: Publication | null
  draft: PublicationEditable
}

// Tab/session memory only. No rendered content, browser storage or server sync.
// Owned by PublicationForm: retain only on explicit template navigation, discard
// on confirmed save or ordinary resource departure. Task17 can clear on logout.
const drafts = new Map<string, PublicationSessionDraft>()
export const readPublicationDraft = (id: string) => {
  const draft = drafts.get(id)
  return draft ? structuredClone(draft) : undefined
}
export const retainPublicationDraft = (
  id: string,
  draft: PublicationSessionDraft,
) => {
  drafts.set(id, structuredClone(draft))
}
export const discardPublicationDraft = (id: string) => {
  drafts.delete(id)
}
export const clearPublicationDrafts = () => {
  drafts.clear()
}

export const publicationsPath = "/telegram/post-bot/publications"
export const publicationPath = (id: string) =>
  `${publicationsPath}/${encodeURIComponent(id)}`
export const publicationValues = ({
  name,
  templateVersionId,
  bindings,
}: Publication): PublicationEditable =>
  structuredClone({ name, templateVersionId, bindings })
